const getters = {
  shopList(state) {
    return state.shopList;
  },
  sortedShopList(state) {
    let list = [...state.shopList.list];
    list.sort((a, b) => (
      Date.parse(b.agency_created) - Date.parse(a.agency_created)
    ))
    return list;
    // return state.shopList.list.slice(
    //   (state.shopList.pagination.page - 1) * state.shopList.pagination.limit,
    //   state.shopList.pagination.page * state.shopList.pagination.limit
    // );
  }
};

export default getters;
